var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiportal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2427 7.31996C11.284 8.36063 11.284 10.0493 10.2427 11.0906L6.47132 14.862C6.21132 15.122 5.78865 15.122 5.52865 14.862L1.75732 11.0906C0.715985 10.0493 0.715985 8.36063 1.75732 7.31929C2.79865 6.27796 4.48732 6.27796 5.52865 7.31929L5.99932 7.79063L6.47132 7.31929C7.51265 6.27796 9.20132 6.27796 10.2427 7.31929V7.31996ZM2.69998 8.26129C2.17998 8.78196 2.17998 9.62663 2.69998 10.1473L5.99998 13.4473L9.29998 10.1473C9.81998 9.62663 9.81998 8.78196 9.29998 8.26129C8.77932 7.74129 7.93465 7.74129 7.41332 8.26263L5.99865 9.67463L4.58532 8.26129C4.06532 7.74129 3.22065 7.74129 2.69998 8.26129ZM5.99998 0.666626C7.47332 0.666626 8.66665 1.85996 8.66665 3.33329C8.66665 4.80663 7.47332 5.99996 5.99998 5.99996C4.52665 5.99996 3.33332 4.80663 3.33332 3.33329C3.33332 1.85996 4.52665 0.666626 5.99998 0.666626ZM5.99998 1.99996C5.26332 1.99996 4.66665 2.59663 4.66665 3.33329C4.66665 4.06996 5.26332 4.66663 5.99998 4.66663C6.73665 4.66663 7.33332 4.06996 7.33332 3.33329C7.33332 2.59663 6.73665 1.99996 5.99998 1.99996Z",
    fill: "#115896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiportal);
export default __webpack_public_path__ + "static/media/miportal.fb243e52081b12009b673e2beef9464d.svg";
export { ForwardRef as ReactComponent };